"use client";
import EventDetailsSkeleton from "@components/UI/EventDetailsSkeleton/EventDetailsSkeleton";
import Navbar from "@layout/Navbar/Navbar";
import { useEffect } from "react";
const Loading = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.reload();
    }, 2000); // 2000 milliseconds (2 seconds)
    return () => clearTimeout(timer); // Clear the timer if the component is unmounted
  }, []);
  return (
    <div>
      <Navbar />
      <EventDetailsSkeleton />
    </div>
  );
};

export default Loading;
